import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Component, OnInit, ViewEncapsulation } from "@angular/core";

@Component({
  selector: "app-modal-spinner",
  templateUrl: "./modal-spinner.component.html",
  styleUrls: ["./modal-spinner.component.scss"],
  encapsulation: ViewEncapsulation.None,
  host: { class: 'ecommerce-application' }
})
export class ModalSpinnerComponent implements OnInit {
  constructor(private modal: NgbActiveModal) {}

  ngOnInit(): void {}

  isModalOpen() {
   // return this.modal.open;
  }
}
